import React from "react";
import "../Styles/Project.css";

import img1 from "../Assets/project1.avif"; 
import img2 from "../Assets/project2.avif"; 

import logo1 from "../Assets/slide-inf-1.webp";
import logo2 from "../Assets/slide-inf-2.webp";
import logo3 from "../Assets/slide-inf-3.webp";
import logo4 from "../Assets/slide-inf-4.webp";
import logo5 from "../Assets/slide-inf-5.webp";
import logo6 from "../Assets/slide-inf-6.webp";
import logo7 from "../Assets/slide-inf-7.webp";
import logo8 from "../Assets/slide-inf-8.webp";
import logo9 from "../Assets/slide-inf-9.webp";
import logo10 from "../Assets/slide-inf-10.webp";

// ✅ Import CountUp Component
import CountUp from "./CountUp";

const Project = () => {
  return (
    <section className="project-section">
      <h2 className="project-heading">Our Projects</h2>
      
      <div className="project-container">
        <div className="project-box">
          <img src={img1} alt="Project 1" className="project-img" />
          <h3 className="pr-h">Client Success</h3>
          <p className="project-text">
            Discover how we’ve helped clients achieve their marketing goals through innovative strategies, enhancing their brand visibility and driving measurable results in competitive markets across Tamil Nadu and beyond.
          </p>
        </div>

        <div className="project-box">
          <img src={img2} alt="Project 2" className="project-img" />
          <h3 className="pr-h">Industry Solutions</h3>
          <p className="project-text">
            We provide tailored digital marketing solutions across various industries, ensuring each project meets unique business needs and delivers measurable results for our clients' success and brand elevation.
          </p>
        </div>
      </div>

      {/* ✅ Logo Slider */}
      <div className="logo-slider">
        <div className="logo-track">
          <img src={logo1} alt="Client 1" />
          <img src={logo2} alt="Client 2" />
          <img src={logo3} alt="Client 3" />
          <img src={logo4} alt="Client 4" />
          <img src={logo5} alt="Client 5" />
          <img src={logo6} alt="Client 6" />
          <img src={logo7} alt="Client 7" />
          <img src={logo8} alt="Client 8" />
          <img src={logo9} alt="Client 9" />
          <img src={logo10} alt="Client 10" />

          {/* Duplicate for infinite loop */}
          <img src={logo1} alt="Client 1" />
          <img src={logo2} alt="Client 2" />
          <img src={logo3} alt="Client 3" />
          <img src={logo4} alt="Client 4" />
          <img src={logo5} alt="Client 5" />
          <img src={logo6} alt="Client 6" />
          <img src={logo7} alt="Client 7" />
          <img src={logo8} alt="Client 8" />
          <img src={logo9} alt="Client 9" />
          <img src={logo10} alt="Client 10" />
        </div>
      </div>

      {/* ✅ CountUp Section */}
    <div className="countup-section">
  <div className="countup-box">
    <span className="count-up-wrapper">
      <CountUp from={0} to={50} duration={2} className="count-up-text" />
      <span className="plus">+</span>
    </span>
    <p>Projects Completed</p>
  </div>

  <div className="countup-box">
    <span className="count-up-wrapper">
      <CountUp from={0} to={3} duration={2} className="count-up-text" />
      <span className="plus">+</span>
    </span>
    <p>Awards</p>
  </div>

  <div className="countup-box">
    <span className="count-up-wrapper">
      <CountUp from={0} to={5} duration={2} className="count-up-text" />
      <span className="plus">+</span>
    </span>
    <p>Years of Experience</p>
  </div>

  <div className="countup-box">
    <span className="count-up-wrapper">
      <CountUp from={0} to={3} duration={2} className="count-up-text" />
      <span className="plus">+</span>
    </span>
    <p>Office Location</p>
  </div>
</div>
    </section>
  );
};

export default Project;
